import { withChartLayout } from 'components/common';
import ChildRiskAssessment from 'components/features/chart/admission-history/child-risk-assessment/ChildRiskAssessment';

const ChildRiskAssessmentPage = withChartLayout('Child Risk Assessment')(ChildRiskAssessment);
export default ChildRiskAssessmentPage;
